import React from 'react'

export default function IconMuted({ muted }: { muted: boolean }) {
  if (muted) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='22'
        viewBox='0 0 24 22'
        fill='none'
      >
        <path
          d='M1.5375 0.5375C1.05 1.025 1.05 1.8125 1.5375 2.3L6.1125 6.875L5.75 7.25H2C1.3125 7.25 0.75 7.8125 0.75 8.5V13.5C0.75 14.1875 1.3125 14.75 2 14.75H5.75L9.8625 18.8625C10.65 19.65 12 19.0875 12 17.975V12.7625L17.225 17.9875C16.6125 18.45 15.95 18.8375 15.225 19.125C14.775 19.3125 14.5 19.7875 14.5 20.275C14.5 21.175 15.4125 21.75 16.2375 21.4125C17.2375 21 18.175 20.45 19.0125 19.775L20.6875 21.45C21.175 21.9375 21.9625 21.9375 22.45 21.45C22.9375 20.9625 22.9375 20.175 22.45 19.6875L3.3125 0.5375C2.825 0.05 2.0375 0.05 1.5375 0.5375ZM20.75 11C20.75 12.025 20.5625 13.0125 20.2375 13.925L22.15 15.8375C22.85 14.375 23.25 12.7375 23.25 11C23.25 6.2125 20.25 2.1125 16.025 0.5C15.2875 0.2125 14.5 0.7875 14.5 1.575V1.8125C14.5 2.2875 14.8125 2.7 15.2625 2.875C18.475 4.175 20.75 7.325 20.75 11ZM9.8625 3.1375L9.65 3.35L12 5.7V4.0125C12 2.9 10.65 2.35 9.8625 3.1375ZM17.625 11C17.625 8.7875 16.35 6.8875 14.5 5.9625V8.2L17.6 11.3C17.6125 11.2 17.625 11.1 17.625 11Z'
          fill='currentColor'
        />
      </svg>
    )
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='22'
      viewBox='0 0 24 22'
      fill='none'
    >
      <path
        d='M0.75 8.50004V13.5C0.75 14.1875 1.3125 14.75 2 14.75H5.75L9.8625 18.8625C10.65 19.65 12 19.0875 12 17.975V4.01255C12 2.90005 10.65 2.33755 9.8625 3.12505L5.75 7.25004H2C1.3125 7.25004 0.75 7.81254 0.75 8.50004ZM17.625 11C17.625 8.78755 16.35 6.88755 14.5 5.96254V16.025C16.35 15.1125 17.625 13.2125 17.625 11ZM14.5 1.56255V1.81255C14.5 2.28755 14.8125 2.70005 15.25 2.87505C18.475 4.16255 20.75 7.32505 20.75 11C20.75 14.675 18.475 17.8375 15.25 19.125C14.8 19.3 14.5 19.7125 14.5 20.1875V20.4375C14.5 21.225 15.2875 21.775 16.0125 21.5C20.25 19.8875 23.25 15.8 23.25 11C23.25 6.20004 20.25 2.11255 16.0125 0.500045C15.2875 0.212545 14.5 0.775045 14.5 1.56255Z'
        fill='currentColor'
      />
    </svg>
  )
}
